// src/styles/kozelBattle/realTimeScore.ts
import { createUseStyles } from 'react-jss';
import { Theme } from '../themes/default';

const useRealTimeScoreStyles = createUseStyles((theme: Theme) => {
    return {
        wrapper: {
            position: 'relative',
            minHeight: '70vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px 40px',
            border: `5px dotted ${theme.colors.espresso_brown}`,
            margin: '0 auto',
            marginTop: theme.spacing(4),
            borderRadius: '10px',
            maxWidth: '1000px',
            overflowX: 'hidden',
            [theme.breakpoints.up('sm')]: {
                padding: '32px 100px', // crește 100px pentru mai mult spațiu
            },
            [theme.breakpoints.up('md')]: {
                padding: '48px 120px', // crește 120px pentru mai mult spațiu
            },
        },
        content: {
            position: 'relative',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        title: {
            fontFamily: theme.fonts.poplar,
            color: theme.colors.espresso_brown,
            fontSize: '2rem',
            textAlign: 'center',
            textTransform: 'uppercase',
            marginBottom: theme.spacing(2),
            lineHeight: 1.2,
            [theme.breakpoints.up('sm')]: {
                fontSize: '3rem',
            },
            [theme.breakpoints.up('md')]: {
                fontSize: '3.5rem',
            },
        },
        subtitle: {
            fontFamily: theme.fonts.apex,
            color: theme.colors.espresso_brown,
            fontSize: '0.85rem',
            textAlign: 'center',
            marginBottom: theme.spacing(2),
            maxWidth: '550px',
            [theme.breakpoints.up('sm')]: {
                fontSize: '0.95rem',
            },
            [theme.breakpoints.up('md')]: {
                fontSize: '1rem',
            },
        },
        realTimeScoreImage: {
            width: '200px',
            height: 'auto',
            marginBottom: theme.spacing(3),
            [theme.breakpoints.up('sm')]: {
                width: '280px',
            },
            [theme.breakpoints.up('md')]: {
                width: '350px',
                marginTop: theme.spacing(2),
                marginBottom: theme.spacing(-3),
                zIndex: 11,
            },
        },
         scoreSection: {
            backgroundColor: theme.colors.latte_cream,
            padding: theme.spacing(3),
            paddingLeft: theme.spacing(1),      // mai putin padding lateral pe mobile
            paddingRight: theme.spacing(1),
            borderRadius: '15px',
            width: 'calc(100% + 48px)',         // depaseste wrapper-ul pe lateral
            marginLeft: '-24px',
            marginRight: '-24px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            position: 'relative',
            [theme.breakpoints.up('sm')]: {
                padding: theme.spacing(4),
                width: 'calc(100% + 80px)',
                marginLeft: '-40px',
                marginRight: '-40px',
            },
            [theme.breakpoints.up('md')]: {
                padding: theme.spacing(5),
                width: 'calc(100% + 120px)',
                marginLeft: '-60px',
                marginRight: '-60px',
            },
        },
        scoresRow: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center', 
            gap: theme.spacing(4), 
            width: '100%',
            marginBottom: theme.spacing(-1),
            paddingLeft: theme.spacing(2), 
            paddingRight: theme.spacing(2),
            [theme.breakpoints.up('md')]: {
                marginBottom: theme.spacing(4),
                gap: theme.spacing(12),
                paddingLeft: theme.spacing(6),
                paddingRight: theme.spacing(6),
                marginTop: theme.spacing(3),
            },
        },
        teamLightContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(0.5),
            [theme.breakpoints.up('sm')]: {
                gap: theme.spacing(1.5),
            },
            [theme.breakpoints.up('md')]: {
                gap: theme.spacing(2),
                paddingTop: theme.spacing(3),
                marginBottom: theme.spacing(-5),
            },
        },
        teamDarkContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(0.5),
            [theme.breakpoints.up('sm')]: {
                gap: theme.spacing(1.5),
            },
            [theme.breakpoints.up('md')]: {
                gap: theme.spacing(2),
                paddingTop: theme.spacing(3),
                marginBottom: theme.spacing(-5),
            },
        },
        likeIcon: {
            width: '40px',
            height: 'auto',
            [theme.breakpoints.up('sm')]: {
                width: '35px',
            },
            [theme.breakpoints.up('md')]: {
                width: '85px',
            },
        },
        lightVsDarkImage: {
            width: '100%',
            maxWidth: '550px',
            height: 'auto',
            [theme.breakpoints.up('sm')]: {
                maxWidth: '650px',
            },
            [theme.breakpoints.up('md')]: {
                maxWidth: '750px',
            },
        },
    };
});

export default useRealTimeScoreStyles;